import React, { useState } from "react";
import ReactHtmlTableToExcel from "react-html-table-to-excel";
import styled from "styled-components";
import NftTable from "./NftTable";

const Root = styled.div``;
const Container = styled.div`
  /* display: flex; */
`;
const TextWrapper = styled.div`
  padding: 30px 20px;
`;
const Text = styled.text`
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  display: flex;
  align-items: center;
`;

const SelecteWrapper = styled.div`
  display: flex;
`;

const Select = styled.select`
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: white;
  font-size: 16px;
  padding: 15px 30px;
  border: none;
  margin: 0 10px;
  outline: none;
  cursor: pointer;
`;
const Option = styled.option`
  background-color: #000;
  font-size: 16px;
  padding: 10px 10px;
  /* background: rgba(255, 255, 255, 0.1); */
  border-radius: 8px;
  cursor: pointer;
  :hover {
    padding: 10px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 8px;
  }
`;

const ButtonWrapper = styled.div``;
const Button = styled.button`
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: white;
  font-size: 16px;
  padding: 15px 30px;
  border: none;
  margin: 0px 10px;
  outline: none;
`;

const FilterShotContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  padding: 5px 40px 5px 20px;
`;

const ShortWrapper = styled.div`
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: white;
  font-size: 16px;
  padding: 15px 30px;
  border: none;
  margin: 0px 10px;
  outline: none;
  cursor: pointer;
`;

const Span = styled.span`
  position: absolute;
  top: 30%;
  right: 75%;
`;
const Arrowwrapper = styled.div``;

const ExportContainer = styled.div`
  position: relative;
  margin: 0 5px;
`;

const Export = styled.button`
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: white;
  font-size: 16px;
  border: none;
  margin: 0px;
  outline: none;
  cursor: pointer;
`;

const CascadingDropdown = () => {
  const Categories = [
    {
      name: "Gun",

      subcategories: [
        {
          name: "Alien Gun",
          type: ["common", "Uncommon", "Rare", "Legendry"],
        },

        {
          name: "Assault",
          type: ["common", "Uncommon", "Rare", "Legendry"],
        },
        {
          name: "Heavy",
          type: ["common", "Uncommon", "Rare", "Legendry"],
        },
        {
          name: "Launcher",
          type: ["common", "Uncommon", "Rare", "Legendry"],
        },
        {
          name: "Pistol",
          type: ["common", "Uncommon", "Rare", "Legendry"],
        },
        {
          name: "ShotGun",
          type: ["common", "Uncommon", "Rare", "Legendry"],
        },
        {
          name: "Smg",
          type: ["common", "Uncommon", "Rare", "Legendry"],
        },
        {
          name: "Sniper",
          type: ["common", "Uncommon", "Rare", "Legendry"],
        },
      ],
    },
    {
      name: "Melee",

      subcategories: [
        {
          name: "Big Axe",
          type: ["common", "Uncommon", "Rare", "Legendry"],
        },
        {
          name: "Dagger",
          type: ["common", "Uncommon", "Rare", "Legendry"],
        },
        {
          name: "Hammer",
          type: ["common", "Uncommon", "Rare", "Legendry"],
        },
        {
          name: "Shield",
          type: ["common", "Uncommon", "Rare", "Legendry"],
        },
        {
          name: "Sword",
          type: ["common", "Uncommon", "Rare", "Legendry"],
        },
      ],
    },
  ];

  // pooja  maurya
  const [selectedName, setSelectedName] = useState("");
  const [selectedSubcategory, setSelectedSubcategory] = useState("");
  const [selectedType, setSelectedType] = useState("");

  // Function to handle the selection of name
  const handleNameChange = (event) => {
    setSelectedName(event.target.value);
    // Reset the subcategory and type selections when name changes
    setSelectedSubcategory("");
    setSelectedType("");
  };

  // Function to handle the selection of subcategory
  const handleSubcategoryChange = (event) => {
    setSelectedSubcategory(event.target.value);
    // Reset the type selection when subcategory changes
    setSelectedType("");
  };

  // Function to handle the selection of type
  const handleTypeChange = (event) => {
    setSelectedType(event.target.value);
  };
  // NEW STATE

  const [category, setCategory] = useState("All");
  const [subcategory, setSubcategory] = React.useState();
  const [type, setType] = useState("All");

  const [subcategories, setSubcategories] = useState([]);

  const [types, setTypes] = useState([]);
  const [showtypeData, setShowTypeData] = useState([]);
  const [selectedState, setSelectedState] = React.useState();

  const changeCategory = (e) => {
    setCategory(e.target.value);
    console.log(Categories, "Categories ppp");
    setSubcategories(
      Categories.find((cat) => cat.name === e.target.value).subcategories
    );
    console.log(subcategories, "poojs");
  };

  const changeSubCat = (e) => {
    setSubcategory(e.target.value);

    console.log(subcategory, "====");
    setTypes(
      subcategories.find((subcategory) => subcategory.name === e.target.value)
        .types
    );
    console.log(types, ".......");
  };

  const typeShowData = () => {
    setShowTypeData(
      subcategory.find((typedata) => typedata.type === e.target.value)
        .showtypeData
    );
  };

  // const changeSubCat = (e)=>{
  //     setSubcategory(e.target.value)
  //     setTypes(subcategories.find((typ) => typ.type.includes(e.target.value)));
  //   };
  // console.log(showtypeData, "showtypeData");

  const changeType = (e) => {
    setType(e.target.value);
    // setType(subcategories);
    setTypes(subcategories.find((user) => user.type === e.target.value).types);
    console.log(type, "type");
  };

  return (
    <Root>
      <Container>
        <TextWrapper>
          <Text>NFT MINT DATA</Text>
        </TextWrapper>

        <FilterShotContainer>
          <SelecteWrapper>
            {/* <Select value={category} onChange={changeCategory}>
              <Option disabled>Categories</Option>
              {Categories.map((ctr) => (
                <Option value={ctr.name}>{ctr.name}</Option>
              ))}
            </Select> */}

            {/* SELECT CATEGORY  */}

            <Select value={selectedName} onChange={handleNameChange}>
              <Option value="">Categories</Option>
              <Option value="all">All</Option>
              {Categories.map((category) => (
                <Option key={category.name} value={category.name}>
                  {category.name}
                </Option>
              ))}
            </Select>

            {/* <Select value={subcategory} onChange={changeSubCat}>
              <Option>Subcategory</Option>
              {subcategories.map((subcat) => (
                <Option value={subcat.name}>{subcat.name}</Option>
              ))}
            </Select> */}

            {/* select  subcategory */}

            <Select
              value={selectedSubcategory}
              onChange={handleSubcategoryChange}
            >
              <Option value=""> Subcategory</Option>
              <Option value="all">All</Option>

              {selectedName === "all"
                ? Categories.flatMap((category) =>
                    category.subcategories.map((subcategory) => (
                      <Option key={subcategory.name} value={subcategory.name}>
                        {subcategory.name}
                      </Option>
                    ))
                  )
                : Categories.find(
                    (category) => category.name === selectedName
                  )?.subcategories.map((subcategory) => (
                    <Option key={subcategory.name} value={subcategory.name}>
                      {subcategory.name}
                    </Option>
                  ))}
            </Select>

            {/* SELECT TYPE   */}

            <Select value={selectedType} onChange={handleTypeChange}>
              <Option value="">Type </Option>
              <Option value="all">All</Option>
              {selectedSubcategory === "all"
                ? Categories.flatMap((category) =>
                    category.subcategories
                      .filter(
                        (subcategory) =>
                          selectedName === "all" ||
                          selectedName === category.name
                      )
                      .flatMap((subcategory) =>
                        subcategory.type.map((type) => (
                          <Option key={type} value={type}>
                            {type}
                          </Option>
                        ))
                      )
                  )
                : Categories.flatMap((category) =>
                    category.subcategories
                      .filter(
                        (subcategory) =>
                          selectedName === "all" ||
                          selectedName === category.name
                      )
                      .find(
                        (subcategory) =>
                          subcategory.name === selectedSubcategory
                      )
                      ?.type.map((type) => (
                        <Option key={type} value={type}>
                          {type}
                        </Option>
                      ))
                  )}
            </Select>

            {/* <Select value={type} onChange={changeType}>
              <Option>Type</Option>

              {showtypeData &&
                showtypeData.map((types) => (
                  <Option value={types.type}>{types.type}</Option>
                ))}
            </Select> */}

            <ExportContainer>
              <Export>
                <Span>
                  <i class="fa-solid fa-upload"></i>
                </Span>
                <ReactHtmlTableToExcel
                  id="test-table-xls-button"
                  className="download-table-xls-button"
                  table="table-to-xls"
                  filename="tablexls"
                  sheet="tablexls"
                  buttonText="Export"
                />
              </Export>
            </ExportContainer>
          </SelecteWrapper>

          <ShortWrapper>
            Sort By
            <Arrowwrapper></Arrowwrapper>
          </ShortWrapper>
        </FilterShotContainer>

        <NftTable />
      </Container>
    </Root>
  );
};

export default CascadingDropdown;